const Description = ({ description }) => {
  const base = 'relative w-full text-bodyMobile lg:text-bodyDesktop font-chivoMono text-umber'
  return (
    <div className={base}>
      <p>{description}</p>
    </div>
  )
}

export default Description
